export default __webpack_public_path__ + "static/media/6.eb42bfb0.png";